export const makeSearchKey = (rawName: string): string =>
  rawName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' '); 